window.TV2 = window.TV2 || {};

window.TV2.initParallax = (containerId, stringifiedLayers) => {
  const layers = JSON.parse(stringifiedLayers);

  const container = document.querySelector(`#parallax-${containerId}`);
  if (container) {
    if ('IntersectionObserver' in window) {
      const elements = [];

      if (layers.length !== 0) {
        layers.forEach((layer) =>
          elements.push({
            index: layer.index,
            selector: `[data-parallax-layer="${layer.selector}"]`,
            animations: layer.animations,
            staticAttributes: layer.staticAttributes,
          }),
        );
      }

      window.dachserData.push('parallax', {
        container,
        elements,
        id: containerId,
      });
    }
  }
};

window.TV2.calculateParallaxContentHeight = (containerId) => {
  const container = document.querySelector(`#parallax-${containerId}`);
  const layers = container.querySelectorAll('.parallax-layer');

  if (TV2.isFacebookInApp() && layers.length > 0) {
    layers.forEach((layer) => {
      // eslint-disable-next-line no-param-reassign
      layer.style.minHeight = `${layer.offsetHeight}px`;
      // eslint-disable-next-line no-param-reassign
      layer.style.height = `${layer.offsetHeight}px`;
      // eslint-disable-next-line no-param-reassign
      layer.style.overflow = 'hidden';
    });
  }
};
